import React from 'react';
import { palette } from '../styles/Palette';

const ExclamationCircle = ({ width = "16", height = "16", color = palette.gray500, ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 15 15" 
      fill="none"
      {...props}
    >
      <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M12.699 7.61511C12.699 10.7076 10.192 13.2146 7.09949 13.2146C4.00698 13.2146 1.5 10.7076 1.5 7.61511C1.5 4.5226 4.00698 2.01562 7.09949 2.01562C10.192 2.01562 12.699 4.5226 12.699 7.61511ZM14.199 7.61511C14.199 11.5361 11.0204 14.7146 7.09949 14.7146C3.17855 14.7146 0 11.5361 0 7.61511C0 3.69417 3.17855 0.515625 7.09949 0.515625C11.0204 0.515625 14.199 3.69417 14.199 7.61511ZM7.61707 9.23577L7.71783 4.77532H6.47203L6.58195 9.23577H7.61707ZM7.10409 9.81188C6.7102 9.81624 6.38501 10.1174 6.38959 10.484C6.38501 10.8593 6.7102 11.1649 7.10409 11.1649C7.48424 11.1649 7.80944 10.8593 7.80944 10.484C7.80944 10.1174 7.48424 9.81624 7.10409 9.81188Z" 
        fill={color}
      />
    </svg>
  );
};

export default ExclamationCircle; 